import { Injectable } from "@angular/core";
import { SharedHttpClientService } from "app/Shared/Services/shared-http-client.service";
import { UrlsService } from 'app/Shared/Services/urls.service';
import { APIURL } from 'app/Shared/Constant/API_Urls';

@Injectable()
export class CatReconService {
    isOpenCommentViewer: boolean = false;
    isDisplayDateRangeFilter: boolean = false;
    isDisplayAddCommentForm: boolean = false;

    constructor(private sharedHttpClientService: SharedHttpClientService,
        private urlsService: UrlsService) {
    }

    getAllCatReconCommentColumnCount(payload:any) {
        return this.sharedHttpClientService.post(this.urlsService.setAPIURl(APIURL.CAT_Column_Comment_Count),  payload);
    }
}